import { Banner, Caption } from '@tabeo/scarf'
import { children } from '@tabeo/sharpei/utils/propTypes'
import Content from 'components/Content'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { useLocation } from 'react-router'

class ErrorBoundary extends Component {
  state = {
    error: null,
  }

  componentDidMount() {
    window.addEventListener('unhandledrejection', this.handleJavaScriptErrors)
    window.addEventListener('error', this.handleJavaScriptErrors)
  }

  componentDidUpdate({ location: { key: oldKey } }) {
    const {
      location: { key },
    } = this.props
    if (key !== oldKey) {
      this.setState({ error: null })
    }
  }

  componentDidCatch(error) {
    // Display fallback UI
    this.setState({ error })
  }

  componentWillUnmount() {
    window.removeEventListener(
      'unhandledrejection',
      this.handleJavaScriptErrors
    )
    window.removeEventListener('error', this.handleJavaScriptErrors)
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  render() {
    const { children } = this.props
    const { error } = this.state
    if (error) {
      return (
        <Content>
          <Banner title="Woops, there was an error" color="red">
            <Caption mt={2}>{error.message}</Caption>
          </Banner>
        </Content>
      )
    }
    return children
  }
}

ErrorBoundary.propTypes = {
  location: PropTypes.object.isRequired,
  children,
}

function ErrorBoundaryWithRouter(props) {
  const location = useLocation()
  return <ErrorBoundary {...props} location={location} />
}

export default ErrorBoundaryWithRouter
